import { registerPlugin } from '@capacitor/core';
import type { NativeLogPlugin } from './definitions';

const NativeLog = registerPlugin<NativeLogPlugin>('NativeLog');

export * from './definitions';
export { NativeLog };
